"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapProbabilitiesToOutcomes = mapProbabilitiesToOutcomes;
const _reduxjs_1 = require("../../../@reduxjs");
const getEventProbabilityOutcomeNameV3_1 = require("./getEventProbabilityOutcomeNameV3/getEventProbabilityOutcomeNameV3");
const hasShortName_1 = require("./hasShortName");
function mapProbabilityToOutcome(args) {
    const { eventProbability, vMarketInfo, outcomeType, eventCompetitors, players, isShortNamed, templateId, } = args;
    const name = (0, getEventProbabilityOutcomeNameV3_1.getOutcomeName)({
        eventProbability,
        vMarketInfo,
        players,
        templateId,
        outcomeType,
        eventCompetitors,
        isShortNamed,
    });
    return {
        ...eventProbability,
        outcomeTypeData: {
            ...outcomeType,
            name,
        },
    };
}
function mapProbabilitiesToOutcomes(args) {
    var _a;
    const { probabilities, vMarketInfo, orderedOutcomeTypes, players, eventCompetitors, clientType, } = args;
    const isShortNamed = (_a = (0, hasShortName_1.hasShortName)(vMarketInfo, clientType)) !== null && _a !== void 0 ? _a : false;
    const templateId = vMarketInfo.outcomesGroup.renderTemplateId;
    const outcomesTypesMap = (0, _reduxjs_1.toIdsMap)(orderedOutcomeTypes);
    const res = {};
    return Object.entries(probabilities).reduce((acc, [key, eventProbability]) => {
        const outcomeType = outcomesTypesMap[eventProbability.outcomeTypeId];
        if (outcomeType) {
            acc[key] = mapProbabilityToOutcome({
                eventProbability,
                outcomeType,
                eventCompetitors,
                clientType,
                vMarketInfo,
                players,
                isShortNamed,
                templateId,
            });
        }
        return acc;
    }, res);
}
//# sourceMappingURL=mapProbsToOutcomes.js.map